import { State } from '../../state/StateTypes';
import {
  selectCurrentColorFilter,
  selectFilterHasSelectableColors,
  selectCurrentSubFilterKey,
  selectCurrentSubFilterValue,
  selectProductMenuFilter,
} from '../../state/productMenu/productMenuSelectors';
import ProductMenuSubFilter from '../../components/ProductMenu/ProductMenuSubFilter';
import store from '../../state';
import ProductMenuColorFilter from '../../components/ProductMenu/ProductMenuColorFilter';
import { FilterExtension } from './productsServiceTypes';

/**
 * Filters items by sub filter
 * @param state
 */
export const subFilter = (state: State) => {
  const subFilterKey = selectCurrentSubFilterKey(state);
  const subFilterValue = selectCurrentSubFilterValue(state);

  return ({ product: { filter } }: any) =>
    subFilterKey && subFilterValue > -1
      ? filter?.[subFilterKey] === subFilterValue
      : true;
};

/**
 * Filters items by color
 * @param state
 */
export const filterProductsByColor = (state: State) => {
  const { colors } = selectProductMenuFilter(state);
  const currentColorFilter = selectCurrentColorFilter(state);
  const hasCurrentColorFilter =
    currentColorFilter && Object.keys(currentColorFilter).length > 0;

  return ({ product }: any) => {
    return colors && hasCurrentColorFilter
      ? product?.filter &&
          currentColorFilter.colors?.some(
            (color: any) => product.filter.color === color
          )
      : true;
  };
};

/**
 * Returns filter object for subfilter
 */
export const subFilterObject = (filterExtension: FilterExtension) => {
  const { condition, appliesTo } = {
    condition: true,
    appliesTo: [],
    ...filterExtension,
  };

  return {
    Component: ProductMenuSubFilter,
    condition: () => {
      const currentFilter = selectProductMenuFilter(store.getState());
      return !!currentFilter.subFilter && condition;
    },
    filter: subFilter,
    appliesTo,
  };
};

/**
 * Returns filter object for colors
 */
export const colorFilterObject = (filterExtension: FilterExtension) => {
  const { condition, appliesTo } = {
    condition: true,
    appliesTo: [],
    ...filterExtension,
  };

  return {
    Component: ProductMenuColorFilter,
    condition: () =>
      selectFilterHasSelectableColors(store.getState()) && condition,
    filter: filterProductsByColor,
    appliesTo,
  };
};
